import React from 'react';
import { styled } from '@mui/material';
import { Colors, DownloadTheAppButtons, Icon, Text, Paper } from 'library';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';

export default function TeacherDownloadCard() {
    return (
        <TeacherCard>
            <Icon
                size={64}
                icon={<PhoneIphoneIcon sx={{ fontSize: 32, color: 'inherit' }} />}
                backgroundColor={Colors.turquoise}
                color={Colors.white}
                style={{ marginBottom: 4 }}
            />
            <Text variant="h2" bold>
                Get the Tandem App
            </Text>
            <Text variant="body2" color={Colors.grey} textStyle={{ maxWidth: 320 }}>
                Teachers create their accounts through the Tandem mobile app. Download it now to get started.
            </Text>
            <DownloadTheAppButtons style={{ justifyContent: 'center', marginTop: 8 }} />
        </TeacherCard>
    );
}

const TeacherCard = styled(Paper)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: 12,
    borderRadius: 12,
    border: `1px solid ${Colors.lightGrey}`,
});
